import React, { Component } from 'react';

import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers';

import { getEnvironment } from '../relayModernEnvironment';
import { QueryRenderer, graphql } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';

import { Error, Loader } from '../shared';
import { TradeSourcingWrapper } from './TradeSourcingWrapper';

const environment = getEnvironment();

export class TradeSourcingContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userId: getBuyerId(document.cookie),
        };
    }

    componentDidMount() {
        addLoginHandlers(() => {
            const newUserId = getBuyerId(document.cookie);
            if (newUserId !== this.state.userId) {
                this.setState({
                    userId: newUserId,
                });
            }
        });
    }

    render() {
        const { userId } = this.state;

        return (
            <QueryRenderer
                environment={environment}
                query={graphql`
                    query TradeSourcingContainerQuery(
                        $userId: String = ""
                        $hasUserId: Boolean = false
                    ) {
                        viewer {
                            ...TradeSourcingWrapper_viewer
                        }
                    }
                `}
                variables={{ userId, hasUserId: !!userId }}
                render={({ error, props }) => {
                    if (error) {
                        return <Error />;
                    } else if (props) {
                        return <TradeSourcingWrapper {...this.props} {...props} />;
                    } else {
                        return <Loader />;
                    }
                }}
            />
        );
    }
}
